//# sourceMappingURL=img.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/img.interface.js
// module id = 1172
// module chunks = 4